/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Use_4_TermInputs */

const en_svc_research_use_4_term = /** @type {(inputs: Svc_Research_Use_4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const lv_svc_research_use_4_term = /** @type {(inputs: Svc_Research_Use_4_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturs`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Svc_Research_Use_4_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_use_4_term = /** @type {((inputs?: Svc_Research_Use_4_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Use_4_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_use_4_term(inputs)
	return en_svc_research_use_4_term(inputs)
});